export const createDisplayedLabels = (labels, labelsMap) => {
  return labels.reduce((labelsArr, label) => {
    const labelDTO = labelsMap[label.id];
    // Patch fix for bug in Menus BM https://github.com/wix-private/restaurants-menus-showcase-bm/pull/1258
    if (labelDTO) {
      labelsArr = [...labelsArr, {
        id: label.id,
        revision: labelDTO.revision,
        name: labelDTO.name,
        icon: labelDTO.icon,
        externalReferenceInfo: labelDTO.externalReferenceInfo
      }];
    }
    return labelsArr;
  }, []);
};
export const getAllItemsLabels = (items, populationLevel) => {
  if (populationLevel != null && populationLevel.labels) {
    return items.reduce((labelsArr, item) => {
      return [...labelsArr, ...(item.labels || [])];
    }, []);
  }
  return items.reduce((labelsArr, item) => {
    return [...labelsArr, ...(item.labels || [])];
  }, []);
};
//# sourceMappingURL=labels.js.map